export const SEMANTIC_SEARCH_FEATURE_ENABLED =
  process.env.REACT_APP_FEATURE_SEMANTIC_SEARCH === "true";
